import PropTypes from 'prop-types'
import { forwardRef } from 'react'

const Identification = forwardRef(({ order, id }, ref) => {
  const { uuid, deviceUuid, standUuid, standMenuUuid, employeeId } = order

  return (
    <section className="order-details__section" id={id} ref={ref}>
      <header className="order-details__header -smaller-margin">
        <h4 className="order-details__main-header">Identification</h4>
      </header>
      <div className="order-details__row">
        <span>Order</span>
        <span className="order-details__row--value">{uuid ?? 'n/a'}</span>
      </div>
      {/* <div className="order-details__row">
        <span>User</span>
        <span className="order-details__row--value">?</span>
      </div> */}
      <div className="order-details__row">
        <span>Device</span>
        <span className="order-details__row--value">{deviceUuid ?? 'n/a'}</span>
      </div>
      <div className="order-details__row">
        <span>Employee</span>
        <span className="order-details__row--value">{employeeId ?? 'n/a'}</span>
      </div>
      {/* <div className="order-details__row">
        <span>Staff</span>
        <span className="order-details__row--value">?</span>
      </div> */}
      <div className="order-details__row">
        <span>Revenue Center</span>
        <span className="order-details__row--value">{standUuid ?? 'n/a'}</span>
      </div>
      <div className="order-details__row">
        <span>Menu</span>
        <span className="order-details__row--value">
          {standMenuUuid ?? 'n/a'}
        </span>
      </div>
    </section>
  )
})

Identification.displayName = 'Identification'

Identification.propTypes = {
  order: PropTypes.object,
  id: PropTypes.string,
}

export default Identification
